<template>
        <CCard>
          <CCardHeader>
                <CRow>
                  <CCol sm="6">
                    <CCallout color="danger">
                      <small class="text-muted">Solde disponible AGP</small><br>
                      <strong class="h4">{{formatted_number(agp_data.total)}}</strong>
                    </CCallout>
                  </CCol>
                  <CCol sm="6">
                    <CCallout color="info">
                      <small class="text-muted">Solde disponible comptabilité</small><br>
                      <strong class="h4">{{formatted_number(accounting_data.total)}}</strong>
                    </CCallout>
                  </CCol>
                </CRow>
          </CCardHeader>
          <CCardBody>
            <div class="progress-group mb-3" v-for="person in Object.keys(agp_data.budgets)" v-bind:key="person">
              <div class="progress-group-header">
                <span class="title">{{person}}</span>
                <span class="ml-auto font-weight-bold">
                  {{formatted_number(agp_data.budgets[person])}}
                  <span class="text-muted small">/ {{formatted_number(accounting_data.budgets[person])}}</span>
                </span>
              </div>
              <div class="progress-group-bars">
                <CProgress
                  class="progress-xs"
                  color="danger"
                  :value="agp_data.budgets[person]/Math.max(agp_data.maximum, accounting_data.maximum)*100"
                />
                <CProgress
                  class="progress-xs"
                  color="info"
                  :value="accounting_data.budgets[person]/Math.max(agp_data.maximum, accounting_data.maximum)*100"
                />
              </div>
            </div>
          </CCardBody>
        </CCard>
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'

export default {
  name: 'Remaining_budgets',
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  components: {
  },
  data () {
    return {
      raw_data: [],
      agp_data: {maximum: 1, total: 0, budgets: {}},
      accounting_data: {maximum: 1, total: 0, budgets: {}},
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/remaining-budgets?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.fill_data())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },
    fill_data() {
      this.agp_data = {
        maximum: this.maximum_budget(this.raw_data.AgpRemainingBudget),
        total: this.budget_total(this.raw_data.AgpRemainingBudget),
        budgets: this.raw_data.AgpRemainingBudget
      },
      this.accounting_data = {
        maximum: Math.max(...Object.values(this.raw_data.AccountingRemainingBudget)),
        total: this.budget_total(this.raw_data.AccountingRemainingBudget),
        budgets: this.raw_data.AccountingRemainingBudget
      }
    },
    maximum_budget(data) {
      return Math.max(...Object.values(data))
    },
    budget_total(data){
      return Object.values(data).reduce((a,b)=> a+b) 
    },
    formatted_number(n) {
      return data_formats.number_format_frch_rounded(n)
    }
  }
}
</script>
